import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../api";

export default function Register() {
  const navigate = useNavigate();

  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setMessage("");

    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    if (password.length < 10) {
      setMessage("Password must be at least 10 characters.");
      return;
    }

    try {
      setLoading(true);

      await registerUser(
        fullName,
        companyName,
        email,
        password
      );

      navigate("/login", {
        replace: true,
        state: {
          message: "Account created successfully. Sign in to continue.",
        },
      });
    } catch (error) {
      setMessage(
        error?.message ||
          "Unable to create your account. Please try again."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <h1 style={titleStyle}>Integrity Suite CRM</h1>

        <div style={subtitleStyle}>
          Create your account to start a 7-day free trial
        </div>

        <p style={{ color: "#b8b8b8", lineHeight: 1.6 }}>After signing in, choose a plan and complete checkout to start your trial. A payment method is required. Monthly billing starts after 7 days unless you cancel before the trial ends.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Full Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            style={inputStyle}
            required
          />

          <input
            type="text"
            placeholder="Business / Company Name"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            style={inputStyle}
            required
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={inputStyle}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
            required
            minLength={10}
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            style={inputStyle}
            required
            minLength={10}
          />

          <button
            type="submit"
            style={primaryButtonStyle}
            disabled={loading}
          >
            {loading ? "Creating Account..." : "Create Account"}
          </button>
        </form>

        {message ? (
          <div style={messageStyle}>{message}</div>
        ) : null}

        <div style={dividerStyle} />

        <div style={existingAccountStyle}>
          Already have an account?
        </div>

        <Link to="/login" style={signInButtonStyle}>
          Sign In
        </Link>
      </div>
    </div>
  );
}

const pageStyle = {
  minHeight: "100vh",
  background: "#050505",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
};

const cardStyle = {
  width: "100%",
  maxWidth: "680px",
  background: "#0d0d0d",
  borderRadius: "28px",
  padding: "40px",
  border: "1px solid rgba(212, 175, 55, 0.45)",
  boxShadow: "0 18px 50px rgba(0,0,0,0.45)",
};

const titleStyle = {
  fontSize: "clamp(42px, 8vw, 72px)",
  fontWeight: "800",
  color: "#ffffff",
  marginBottom: "18px",
  lineHeight: 1,
};

const subtitleStyle = {
  fontSize: "18px",
  color: "#b8b8b8",
  marginBottom: "28px",
};

const inputStyle = {
  width: "100%",
  padding: "18px 20px",
  borderRadius: "16px",
  border: "1px solid #333333",
  background: "#151515",
  color: "#ffffff",
  fontSize: "18px",
  boxSizing: "border-box",
  marginBottom: "18px",
  outline: "none",
};

const primaryButtonStyle = {
  width: "100%",
  padding: "18px",
  borderRadius: "16px",
  border: "none",
  background: "#D4AF37",
  color: "#050505",
  fontSize: "18px",
  fontWeight: "800",
  cursor: "pointer",
};

const messageStyle = {
  marginTop: "20px",
  padding: "18px",
  borderRadius: "16px",
  background: "#151515",
  border: "1px solid #333333",
  fontSize: "16px",
  color: "#ffffff",
};

const dividerStyle = {
  height: "1px",
  background: "#2b2b2b",
  margin: "30px 0 24px",
};

const existingAccountStyle = {
  textAlign: "center",
  color: "#b8b8b8",
  fontSize: "16px",
  marginBottom: "14px",
};

const signInButtonStyle = {
  display: "block",
  width: "100%",
  padding: "17px",
  borderRadius: "16px",
  border: "1px solid #D4AF37",
  color: "#D4AF37",
  background: "#0d0d0d",
  textDecoration: "none",
  textAlign: "center",
  boxSizing: "border-box",
  fontSize: "18px",
  fontWeight: "700",
};
